import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IAddEditSahraUserGroupFormValues,
  SahraUserGroupsSlice,
} from "../../Interfaces/sahraUserGroupsInterfaces";

const initialState: SahraUserGroupsSlice = {
  formValues: {} as IAddEditSahraUserGroupFormValues,
  tableRefreshFlag: false,
};

const sahraUserGroupSlice = createSlice({
  name: "sahraUserGroup",
  initialState,
  reducers: {
    sahraUserGroupsFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      store.formValues = {
        ...store.formValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setSahraUserGroupsFormValues: (
      store,
      action: PayloadAction<IAddEditSahraUserGroupFormValues>
    ) => {
      store.formValues = action.payload;
    },
    setSahraUserGroupsTableFlag: (store, action: PayloadAction<boolean>) => {
      store.tableRefreshFlag = action.payload;
    },
  },
});

export const {
  sahraUserGroupsFormValuesChangeHandler,
  setSahraUserGroupsTableFlag,
  setSahraUserGroupsFormValues,
} = sahraUserGroupSlice.actions;
export default sahraUserGroupSlice.reducer;
